import dictionary from 'sky-engine/utils/dictionary'

const localDictionary = {
  flowStatus: {
    MDR_PROJECT_INIT: { label: 'dictionary.flowStatus.MDR_PROJECT_INIT', type: 'primary' },
    MDR_SCENE_RESEARCH: { label: 'dictionary.flowStatus.MDR_SCENE_RESEARCH', type: 'danger' },
    MDR_SCENE_COLLECT: { label: 'dictionary.flowStatus.MDR_SCENE_COLLECT', color: '#2cb9e3' },
    MDR_PROJECT_ENV: { label: 'dictionary.flowStatus.MDR_PROJECT_ENV', color: '#f1c114' },
    MDR_TEST_CASE: { label: 'dictionary.flowStatus.MDR_TEST_CASE', color: '#71a905' },
    CREATE_ORDER: { label: 'dictionary.flowStatus.CREATE_ORDER', type: 'success' }
  },
  deliveryFlowStatus: {
    MDR_DEPLOY_TO_BE_CREATE: { label: 'dictionary.flowStatus.MDR_DEPLOY_TO_BE_CREATE', type: 'primary' },
    MDR_DEPLOY_PROJECT_INIT: { label: 'dictionary.flowStatus.MDR_DEPLOY_PROJECT_INIT', type: 'danger' },
    MDR_DEPLOY_JOB_PC_INFO: { label: 'dictionary.flowStatus.MDR_DEPLOY_JOB_PC_INFO', type: '#2cb9e3' },
    MDR_DEPLOY_REQUIREMENT_CHECK: {
      label: 'dictionary.flowStatus.MDR_DEPLOY_REQUIREMENT_CHECK',
      type: '#f1c114'
    },
    MDR_DEPLOY_NETWORK_INFO: { label: 'dictionary.flowStatus.MDR_DEPLOY_NETWORK_INFO', type: '#71a905' },
    MDR_DEPLOY_SOLUTION_BUILD: { label: 'dictionary.flowStatus.MDR_DEPLOY_SOLUTION_BUILD', type: 'success' }
  },
  collectType: {
    SOFTWARE: { label: '软件', type: 'primary' },
    PERIPHERAL: { label: '外设', type: 'success' }
  },
  type: {
    SOFTWARE: { label: '软件', type: 'primary' },
    PERIPHERAL: { label: '外设', type: 'success' },
    HIGH_CPU_SPEED: { label: '高主频', type: 'success' },
    SCENE_CONFIG: { label: '场景默认配置', type: 'warning' }
  },
  softwareType: {
    ANTIVIRUS: { label: '杀毒软件', type: 'primary' },
    ENCRPYTION: { label: '加密软件', type: 'success' }
  },
  approvalStatus: {
    PENDING: { label: '待审批', type: 'ing' },
    APPROVED: { label: '通过', type: 'success' },
    REJECTED: { label: '不通过', type: 'danger' }
  },
  productDataType: {
    SOFTWARE: { label: '软件', type: 'success', tagType: 'success' },
    AUTHORIZATION: { label: '授权', type: 'success', tagType: 'success' },
    TERMINAL: { label: '终端', type: 'success', tagType: 'warning' },
    SERVER: { label: '服务器', type: 'success', tagType: 'warning' },
    PERIPHERAL: { label: '外设', type: 'success', tagType: 'warning' },
    ALL_IN_ONE_PC: { label: '一体机', type: 'success', tagType: 'info' },
    CLOUD_ALL_IN_ONE_PC: { label: '云一体机', type: 'success', tagType: 'info' },
    CLOUD_TERMINAL: { label: '云终端', type: 'success', tagType: 'info' },
    UNKNOWN: { label: '未知', type: 'success', tagType: 'danger' }
  },
  sceneType: {
    BUSI_SCENE: { label: '业务场景', type: 'info' },
    DEPLOY_SCENE: { label: '部署场景', type: 'warning' },
    SECURITY_SCENE: { label: '安全场景', type: 'danger' },
    COMMON_SCENE: { label: '通用场景', type: 'success' },
    LIMIT_SCENE: { label: '禁止场景', type: 'danger' }
  },
  compatibleStatus: {
    SUPPORT: { label: '兼容', type: 'success' },
    NOT_SUPPORTED: { label: '不兼容', type: 'danger' },
    LIMITED_SUPPORT: { label: '限制兼容', type: 'warning' },
    SECTION_SUPPORT: { label: '部分兼容', type: 'info' }
  },
  featureType: {
    REQUIRED: { label: '必选', type: 'success' },
    RECOMMEND: { label: '推荐', type: 'primary' },
    OPTIONAL: { label: '可选', type: 'warning' },
    null: { label: '可选', type: 'warning' }
  },
  deliveryFeatureType: {
    REQUIRED: { label: '必选', type: 'success' },
    RECOMMEND: { label: '推荐', type: 'primary' },
    OPTIONAL: { label: '可选', type: 'warning' },
    null: { label: '可选', type: 'warning' }
  },
  testCaseCategory: {
    NORMAL: { label: '系统录入', type: 'primary' },
    SHARED: { label: '个人提供', type: 'success' }
  },
  testCaseType: {
    BUSINESS: { label: '功能用例', type: 'primary' },
    PERIPHERAL: { label: '外设用例', type: 'success' },
    SOFTWARE: { label: '软件用例', type: 'warning' }
    // PERIPHERAL_COLLECT: { label: '外设用例', type: 'success' },
    // SOFTWARE_COLLECT: { label: '软件用例', type: 'info' }
  },
  relevant: {
    COMMON: { label: '通用', type: 'success' },
    SPEC: { label: '专属', type: 'primary' }
  },
  featureCategory: {
    COMMON: { label: '通用', type: 'success' },
    SPEC: { label: '专属', type: 'primary' }
  },
  hasPush: {
    false: { label: '否', type: 'primary' },
    true: { label: '是', type: 'success' }
  },
  hasCompatible: {
    false: { label: '否', type: 'primary' },
    true: { label: '是', type: 'success' }
  },
  collectSourceFrom: {
    PERSONAL: { label: '非项目', type: 'warning' },
    PROJECT: { label: '项目', type: 'danger' }
  },
  toolCategory: {
    POC: { label: '售前测试', type: 'primary' },
    PSC: { label: '交付部署', type: 'success' },
    OPERATION: { label: '客户运营', type: 'warning' },
    HALO: { label: 'Halo工具商店', type: 'info' },
    OTHERS: { label: '其它工具', type: 'danger' }
  },
  provideMode: {
    NORMAL: { label: '普通链接', type: 'primary' },
    PROTECTION: { label: '防盗链接', type: 'success' }
  },
  toolStatus: {
    ON_SHELF: { label: '上架', type: 'success' },
    OFF_SHELF: { label: '下架', type: 'danger' }
  },
  toolSource: {
    ONE_CLICK: { label: '运维服务台', type: 'primary' },
    WSP: { label: '运营平台', type: 'success' },
    HALO: { label: 'HALO', type: 'warning' }
  },
  toolDeployRange: {
    RUI: { label: '小锐工具箱', type: 'primary' },
    WSP: { label: '运营平台', type: 'success' },
    HALO: { label: 'Halo工具箱', type: 'warning' }
  },
  guideType: {
    VALUE_GUIDE: { label: '价值配置指导', type: 'primary' },
    POSITION_GUIDE: { label: '岗位桌面配置指导', type: 'success' },
    ATTENTION_GUIDE: { label: '注意事项指导', type: 'warning' }
  },
  npsStrategy: {
    FIRST_USE: { label: '首次使用后开启NPS', type: 'primary' },
    PROJ_CREATE: { label: '项目创建后开启NPS', type: 'success' },
    PROJ_FINISH: { label: '项目结束后开启NPS', type: 'warning' }
  },
  projectSourceType: {
    OEM: { label: '原厂', type: 'primary' },
    PARTNER: { label: '合作伙伴', type: 'success' }
  }
}

for (const key in localDictionary) {
  // eslint-disable-next-line no-prototype-builtins
  if (localDictionary.hasOwnProperty(key)) {
    dictionary[key] = localDictionary[key]
  }
}
export default dictionary
